import type { Platform } from '@/types/market'

/**
 * Generate the URL for an event/market detail page
 * All platforms now use the unified v2 routing: /v2/{platform}/{eventId}
 */
export function getEventUrl(
	platform: Platform,
	eventId: string,
	options?: { marketId?: string; side?: 'yes' | 'no' }
): string {
	const basePath = `/v2/${platform}/${eventId}`

	if (options?.marketId || options?.side) {
		const params = new URLSearchParams()
		if (options.marketId) params.set('marketId', options.marketId)
		if (options.side) params.set('side', options.side)
		return `${basePath}?${params.toString()}`
	}

	return basePath
}

/**
 * Generate full URL with origin for sharing
 */
export function getEventShareUrl(platform: Platform, eventId: string, baseUrl?: string): string {
	const path = getEventUrl(platform, eventId)
	if (baseUrl) {
		return `${baseUrl}${path}`
	}
	if (typeof window !== 'undefined') {
		return `${window.location.origin}${path}`
	}
	return path
}
